import React, { useEffect } from 'react';
import { KodanshaNavbar } from './KodanshaNavbar/KodanshaNavbar';
import { useAtom, useAtomValue } from 'jotai';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ArticleAtomFamily, ArticleFetchState, FetchNewsAtom } from '../store/NewsArticleStore';
import './KodanshaArticle.scss';
import EmailVerifiedPage from './Articles/EmailVerifiedPage';
import KodanshaSubscription from './KodanshaSubscription/KodanshaSubscription';
import { KodanshaFooter } from './KodanshaFooter/KodanshaFooter';
import { KodanshaNotFound } from './KodanshaNotFound/KodanshaNotFound';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import Log from './Services/Logger';
import { ArticleContent } from './ArticleContent/ArticleContent';
import { Link } from '../Devon/Components/InkyLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { readerReadableUrlOrDefault } from '../utils/utils';
import { AccountInfoAtom } from '../store/AccountStore';

const checkParamsIfUndefined = (year, month, day, aid): boolean => {
    return [year, month, day, aid].some(param => param === undefined);
};

export interface KodanshaArticleParams {
    year?: string;
    month?: string;
    day?: string;
    aid?: string;
}

interface KodanshaArticleProps {
    overrideUrl?: string;
}

export function KodanshaArticle(props: KodanshaArticleProps): JSX.Element {
    const { year, month, day, aid } = useParams<KodanshaArticleParams>();
    const history = useHistory();
    const queryParameters = new URLSearchParams(window.location.search);
    const location = useLocation();
    Log.info("OverrideUrl" + props.overrideUrl);
    console.log(queryParameters);

    if (history.location.pathname === '/email-verified') {
        EmailVerifiedPage();
    }

    // This is unsafe, we should seek another solution to get the type of the page in custom pages from server
    if (!checkParamsIfUndefined(year, month, day, aid)) {

    }

    function getUrl() {
        if (props.overrideUrl !== undefined && props.overrideUrl !== null && props.overrideUrl !== '') {
            return props.overrideUrl;
        }
        if (year && month && day) {
            return `${year}/${month}/${day}/${aid}`;
        }
        if (aid === undefined || aid === null || aid === '') {
            if (location.pathname.startsWith('/')) {
                return location.pathname.slice(1);
            }
            return location.pathname;
        }

        return aid;
    }

    const url = getUrl();


    const [articleFetchStatus, fetchArticle] = useAtom(FetchNewsAtom(url));

    useEffect(() => {
        // Fetch the article on mount only.
        //TODO: FIGURE OUT WHY AN ARGUMENT IS NEEDED HERE,
        // I have no clue my compiler needs it, but webstorm gives no indication
        fetchArticle();
    }, []);


    if (articleFetchStatus === ArticleFetchState.Fetched) {
        return (
            <div className={'kodansha-article-container'}>
                <FoundArticle url={url} year={year}/>
                <KodanshaSubscription />
                <KodanshaFooter />
            </div>
        );
    }

    // ... or return a 404 if there is no article returned.
    if (articleFetchStatus === ArticleFetchState.Error) {
        return (<KodanshaNotFound />);
    }


    return <KodanshaNavbar />;
}

interface FoundArticleProps {
    url: string;
    year?: string;
}

function FoundArticle(props: FoundArticleProps): JSX.Element {
    const articleWrapper = useAtomValue(ArticleAtomFamily(props.url));
    const accountInfo = useAtomValue(AccountInfoAtom);

    const article = articleWrapper?.article;
    if(!article) {
        return null;
    }
    if (article) {
        ReactGA.send({ hitType: 'pageview', page: window.location.href, title: 'News | ' + article.title });
    }
    Log.debug("Article content:",article);

    return (
        <React.Fragment>
            <Helmet>
                <title>{article?.title ?? "Kodansha – Inspire Impossible Stories"}</title>
            </Helmet>
            <KodanshaNavbar />
            <ArticleContent id={article.id} style={article.style} strips={article.strips} />
            {accountInfo.roles?.find(x => x.toLowerCase() == 'admin') ?
                <div className={'product-admin-edit'}>
                    <Link
                        className='edit-product-for-admin'
                        to={`/dashboard/${article.pageType === 'News' ? 'news' : 'custom-pages'}/${article.id}`}
                    >
                        <FontAwesomeIcon icon={faEdit} size='2x' />
                        <span>
                                Edit Article
                            </span>
                    </Link>
                </div>
                : null}
        </React.Fragment>
);
}
